import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

import {
  INSTRUMENT_DASHBOARD_LAYOUT,
  INSTRUMENT_DASHBOARD_PAGE_SX,
  QUESTION_DRILLDOWN_LAYOUT,
} from '../lib/instrument-dashboard-layout'
import {
  QUESTION_SUMMARY_LAYOUT,
  QUESTION_SUMMARY_SECTION_SX,
} from '../lib/question-summary-display'

/** Layout-shaped loading state for the question drill-down page. */
export function QuestionDrillDownPageSkeleton() {
  return (
    <Box
      data-testid="question-drilldown-skeleton"
      aria-busy
      aria-label="Loading question dashboard"
      sx={INSTRUMENT_DASHBOARD_PAGE_SX}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        sx={{ mb: INSTRUMENT_DASHBOARD_LAYOUT.titleBlockToBreadcrumb }}
      >
        <Stack spacing={INSTRUMENT_DASHBOARD_LAYOUT.titleToSubtitle} sx={{ flex: 1, minWidth: 0 }}>
          <Skeleton variant="text" width={260} height={32} />
          <Skeleton variant="text" width={420} height={20} />
        </Stack>
        <Skeleton variant="rounded" width={72} height={28} sx={{ borderRadius: '12px' }} />
      </Stack>
      <Skeleton
        variant="text"
        width={520}
        height={20}
        sx={{ mb: INSTRUMENT_DASHBOARD_LAYOUT.breadcrumbToMetrics }}
      />
      <Box sx={{ ...QUESTION_SUMMARY_SECTION_SX, mb: QUESTION_DRILLDOWN_LAYOUT.summaryToFilterTabs }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: QUESTION_SUMMARY_LAYOUT.sectionGap }}>
          <Box sx={{ display: 'flex', gap: QUESTION_SUMMARY_LAYOUT.headerGap }}>
            <Skeleton variant="rounded" width={40} height={40} sx={{ borderRadius: '8px', flexShrink: 0 }} />
            <Stack spacing={0.5} sx={{ flex: 1 }}>
              <Skeleton variant="rounded" width={120} height={24.5} sx={{ borderRadius: '16px' }} />
              <Skeleton variant="text" width="80%" height={40} />
            </Stack>
          </Box>
          <Box
            sx={{
              pt: QUESTION_SUMMARY_LAYOUT.metricsTopPadding,
              display: 'grid',
              gap: QUESTION_SUMMARY_LAYOUT.metricsGridGap,
              gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
              gridTemplateRows: { md: QUESTION_SUMMARY_LAYOUT.metricsGridRowHeight },
              alignItems: 'start',
            }}
          >
            {[0, 1, 2, 3].map((i) => (
              <Skeleton
                key={i}
                variant="rounded"
                height={76}
                sx={{ borderRadius: QUESTION_SUMMARY_LAYOUT.metricTileRadius, width: '100%' }}
              />
            ))}
          </Box>
        </Box>
      </Box>
      <Skeleton
        variant="rounded"
        width={280}
        height={48}
        sx={{
          mb: QUESTION_DRILLDOWN_LAYOUT.filterTabsToChart,
          borderRadius: '18px',
          alignSelf: 'flex-start',
        }}
      />
      <Skeleton
        variant="rounded"
        height={360}
        sx={{ mb: QUESTION_DRILLDOWN_LAYOUT.chartToFindings, borderRadius: '12px' }}
      />
      <Skeleton variant="rounded" height={220} sx={{ borderRadius: '12px' }} />
    </Box>
  )
}
